import { FCX } from "@datassential/platform-ui-lib";
import SectionReports from "@pages/Food/legacy/components/SectionReports/SectionReports";
import { useFoodProfileDocuments } from "@apiHooks/useFoodProfileDocuments";
import SectionCharts from "@pages/Food/legacy/components/SectionCharts/SectionCharts";

const FoodSectionsDocuments: FCX<{
    word: string;
    setHasReports: (hasReports: boolean) => void;
    setHasCharts: (hasCharts: boolean) => void;
}> = ({
    word,
    setHasReports,
    setHasCharts,
}) => {
    const {
        data: {
            reports,
            macAndInstantChart,
        },
        isLoading,
    } = useFoodProfileDocuments(word);

    return (<>
        <SectionReports
            word={word}
            data={reports}
            isLoading={isLoading}
            setHasData={setHasReports}
        />
        <SectionCharts
            data={macAndInstantChart}
            word={word}
            isLoading={isLoading}
            setHasData={setHasCharts}
        />
    </>);
}

export default FoodSectionsDocuments;